import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import i18n from "../../../i18n";
import { withTranslation } from "react-i18next";

// falgs
import brazil from "../../../assets/images/flags/brazil.jpg";
import usFlag from "../../../assets/images/flags/us.jpg";
import spain from "../../../assets/images/flags/spain.jpg";

const LanguageDropdown = () => {
  const [menu, setMenu] = useState(false);
  const [lng, setLng] = useState("Portuguese");
  const [flag, setFlag] = useState(brazil);

  useEffect(() => {
    setLanguageState(i18n.language);
  }, [])

  const setLanguageState = (lng) => {

    if (lng === "pt") {
      setLng((lng = "Portuguese"));
      setFlag(brazil);
    }else if (lng === "sp") {
      setLng((lng = "Spanish"));
      setFlag(spain);
    } else if (lng === "eng") {
      setLng((lng = "English"));
      setFlag(usFlag);
    }
  }
  const changeLanguageAction = (lng) => {
    //set language as i18n
    i18n.changeLanguage(lng);

    setLanguageState(lng);
  };

  const toggle = () => {
    setMenu(!menu);
  };

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <DropdownToggle className="btn header-item waves-effect" tag="button">
          <img src={flag} alt="Skote" height="16" className="mr-1" />
          <span className="align-middle">{lng}</span>
        </DropdownToggle>
        <DropdownMenu className="language-switch" right>
        <DropdownItem
            tag="a"
            href="#"
            onClick={() => changeLanguageAction("pt")}
            className="notify-item"
          >
            <img src={brazil} alt="Skote" className="mr-1" height="12" />
            <span className="align-middle">Portuguese</span>
          </DropdownItem>
          <DropdownItem
            tag="a"
            href="#"
            onClick={() => changeLanguageAction("eng")}
            className="notify-item"
          >
            <img src={usFlag} alt="Skote" className="mr-1" height="12" />
            <span className="align-middle">English</span>
          </DropdownItem>
          <DropdownItem
            tag="a"
            href="#"
            onClick={() => changeLanguageAction("sp")}
            className="notify-item"
          >
            <img src={spain} alt="Skote" className="mr-1" height="12" />
            <span className="align-middle">Spanish</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(LanguageDropdown);
